import styled from "styled-components";

export const StyledLoading = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: var(--spacing-sm);
  h3 {
    color: var(--color-white);
    font-size: var(--font-size-xl);
    font-weight: 600;
  }
`;
